import { DotLabel } from "components/Dot";
import ListTemplate from "components/ListTemplate";
import { PromoterSidePanel } from "components/SidePanel/Company/CompanySidePanel";
import TagList from "components/Tag/TagList";
import React from "react";
import { useLoaderData } from "react-router";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";

const PromoterListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.PromoterListFrontModel>();

  return <ListTemplate
    title={site.currentEnvironment.functionGroups.promoter.plural}
    filterSet="company_Promoter_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Promoter.Paginated}
    getId={item => item.companyId}
    layout={{
      type: "table",
      columns: [{
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <PromoterSidePanel companyId={item.companyId} trigger={<a>{item.name}</a>} />,
        size: "2fr"
      }, {
        key: "city",
        header: RESX.Address.City,
        render: item => item.cityCountry,
        size: "2fr"
      }, {
        key: "financialRisk",
        header: RESX.Promoter.FinancialRisk,
        render: item => item.financialRiskLevel.value !== "unknown" && <DotLabel dotColor={item.financialRiskLevel.hexColor}>{item.financialRiskLevel.text}</DotLabel>,
        size: "1fr"
      }, {
        key: "tags",
        header: "",
        render: item => <TagList tags={item.tags} length="short" />,
        size: "fit-content(200px)"
      }]
    }}
    filters={<Filters initialTags={viewModel.tags} />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
  />;
};

export default PromoterListApp;
